var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoC = function SvgLogoC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 54.181 59.063",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.744 54.775c-7.343 0-12.891-2.45-16.489-7.283-3.48-4.671-5.244-11.414-5.244-20.044 0-9.959 1.528-17.077 4.673-21.76a16.1 16.1 0 0 1 6.363-5.692A35.9 35.9 0 0 0 16.08 3.237 28.73 28.73 0 0 0 4.357 13.453 28.83 28.83 0 0 0 0 29.543c0 6.373 1.343 11.8 3.994 16.138a26.24 26.24 0 0 0 10.8 9.935 34.05 34.05 0 0 0 15.369 3.446 30 30 0 0 0 15.209-3.7 22.5 22.5 0 0 0 5.367-4.3 22 22 0 0 1-2.222 1.413 22.3 22.3 0 0 1-10.773 2.3",
    "data-name": "Path 969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.901 3.047a16.2 16.2 0 0 1 0 4.339 24 24 0 0 0-.118 4.255 9.5 9.5 0 0 0 2.3 5.723 6.2 6.2 0 0 0 4.861 2.017 6.8 6.8 0 0 0 4.623-1.489 4.99 4.99 0 0 0 1.617-4.036 11.3 11.3 0 0 0-2.41-6.791 17.8 17.8 0 0 0-7.283-5.531A23.3 23.3 0 0 0 39.551 0a7.3 7.3 0 0 1 1.316 2.854 2 2 0 0 1 .037.193",
    "data-name": "Path 970"
  }))));
};
export default SvgLogoC;